export const DEFAULT_TASK_TITLE = 'New Task';
